import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfoCircleCountry = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.9987 15.1668C4.04536 15.1668 0.832031 11.9535 0.832031 8.00016C0.832031 4.04683 4.04536 0.833496 7.9987 0.833496C11.952 0.833496 15.1654 4.04683 15.1654 8.00016C15.1654 11.9535 11.952 15.1668 7.9987 15.1668ZM7.9987 1.8335C4.5987 1.8335 1.83203 4.60016 1.83203 8.00016C1.83203 11.4002 4.5987 14.1668 7.9987 14.1668C11.3987 14.1668 14.1654 11.4002 14.1654 8.00016C14.1654 4.60016 11.3987 1.8335 7.9987 1.8335Z",
			fill: "#7548F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 11.1668C7.72667 11.1668 7.5 10.9402 7.5 10.6668V7.3335C7.5 7.06016 7.72667 6.8335 8 6.8335C8.27333 6.8335 8.5 7.06016 8.5 7.3335V10.6668C8.5 10.9402 8.27333 11.1668 8 11.1668Z",
			fill: "#7548F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.9987 5.9965C7.91203 5.9965 7.82536 5.9765 7.74536 5.94317C7.66536 5.90984 7.59203 5.86317 7.52536 5.80317C7.46536 5.7365 7.4187 5.66984 7.38536 5.58317C7.35203 5.50317 7.33203 5.4165 7.33203 5.32984C7.33203 5.24317 7.35203 5.1565 7.38536 5.0765C7.4187 4.9965 7.46536 4.92317 7.52536 4.8565C7.59203 4.7965 7.66536 4.74984 7.74536 4.7165C7.90536 4.64984 8.09203 4.64984 8.25203 4.7165C8.33203 4.74984 8.40536 4.7965 8.47203 4.8565C8.53203 4.92317 8.5787 4.9965 8.61203 5.0765C8.64536 5.1565 8.66536 5.24317 8.66536 5.32984C8.66536 5.4165 8.64536 5.50317 8.61203 5.58317C8.5787 5.66984 8.53203 5.7365 8.47203 5.80317C8.40536 5.86317 8.33203 5.90984 8.25203 5.94317C8.17203 5.9765 8.08536 5.9965 7.9987 5.9965Z",
			fill: "#7548F0"
		})
	]
});
export default SvgInfoCircleCountry;
